const prod = process.env.NODE_ENV === "production";
const windowEnv = window.Environment ? window.Environment : false;
let isDevEnv = false;
if (windowEnv === "dev") {
    isDevEnv = true;
}
let isDev = function () {
    return isDevEnv;
};

let getHeight = function (elem) {
    //https://jsfiddle.net/xuumzf9k/1/
    let el_style = window.getComputedStyle(elem),
        el_display = el_style.display,
        el_position = el_style.position,
        el_visibility = el_style.visibility,
        el_max_height = el_style.maxHeight.replace("px", "").replace("%", ""),
        wanted_height = 0;

    // if its not hidden we just return normal height
    if (el_display !== "none" && el_max_height !== "0") {
        return elem.offsetHeight;
    }

    console.log("show elem to get height");
    // the element is hidden so:
    // making the el block so we can measure its height but still be hidden
    elem.style.position = "absolute";
    elem.style.visibility = "hidden";
    elem.style.display = "block";

    wanted_height = elem.offsetHeight;

    // reverting to the original values
    elem.style.display = "";
    elem.style.position = "";
    elem.style.visibility = "";
    // elem.style.display = el_display;
    // elem.style.position = el_position;
    // elem.style.visibility = el_visibility;

    return wanted_height;
};

// Making all functions available in this
// module to exports that we have made
// so that we can import this module and
// use these functions whenever we want.
export { getHeight, isDev };
